import script from "./services.vue?vue&type=script&setup=true&lang=js"
export * from "./services.vue?vue&type=script&setup=true&lang=js"

import "./services.vue?vue&type=style&index=0&id=bef547e2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bef547e2"]])

export default __exports__